export class JobPo {
    vendorId: number;
    vendorName: string;
    financialVendorNumber: string;
    doingBusinessAsName: string;
    tradeCategoryNames: string;
    purchaseOrderNumber: string;
    versionNumber: string;
    documentGuid: string;
}

export class JobPoVendorGroup {
    vendorId: number;
    vendorName: string;
    financialVendorNumber: string;
    doingBusinessAsName: string;
    purchaseOrders: JobPo[];
}
